export default {
  hide: 'Hide',
  end: 'End',
  keypad: 'Keypad',
} as const;
